import { render, staticRenderFns } from "./Rounds.vue?vue&type=template&id=509eb545&scoped=true"
import script from "./Rounds.vue?vue&type=script&lang=js"
export * from "./Rounds.vue?vue&type=script&lang=js"
import style0 from "./Rounds.vue?vue&type=style&index=0&id=509eb545&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509eb545",
  null
  
)

export default component.exports